/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const allocationSummarySchema = z.object({
  totalExpectedEffort: z.int(),
  totalHighEffort: z.int(),
  totalItems: z.int(),
  totalLowEffort: z.int(),
});
